import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/informationCenter/main"));

const Nomination = () => {
  return (
    <Layout pageHeading="Information Center">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
      </Layout>
    
  );
};

export default Nomination;
